<div
  *ngIf="disclaimers?.length"
  class="disclaimers"
  [ngClass]="ccss.getClass('disclaimers')"
>
  <zelis-banner-list data-cy="disclaimers.banner-list">
    <zelis-banner
      *ngFor="let disclaimer of disclaimers; trackBy: trackByFn; let i = index"
      [status]="levels[disclaimer.level]"
      [container]="container"
      [dismissible]="disclaimer.dismissible"
      [expanded]="disclaimer.expanded"
      [clamp]="clamp"
      [showMoreText]="'app_global_show_more' | translate"
      [showLessText]="'app_global_show_less' | translate"
      [attr.data-cy]="'disclaimers.banner.' + i"
      [translations]="'app_global_' + levels[disclaimer.level] | translate"
    >
      <span [innerHTML]="disclaimer.text | translate"></span>
    </zelis-banner>
  </zelis-banner-list>
</div>
